import { Modal } from "react-bootstrap";
import WaitingListForm from "./WaitingListForm";
import { leadTimeFor } from "../../config/queue";

/* Shop-card entry point to the waiting list. */
function WaitingListModal({ show, onHide, productName }) {
  return (
    <Modal show={show} onHide={onHide} centered size="lg" className="sb-modal">
      <Modal.Header closeButton className="border-0 pb-0" />
      <Modal.Body className="px-4 px-md-5 pb-5 pt-0">
        <span className="sb-eyebrow">Waiting list</span>
        <h3 className="fw-bold mb-3">The {productName}</h3>
        <p className="text-muted mb-4">
          Every speaker is built by hand to order — the {productName} takes{" "}
          <strong className="text-body">{leadTimeFor(productName)}</strong>.
          Join the waiting list and we will contact you with a lead time.
          Nothing is paid now.
        </p>
        <WaitingListForm product={productName} />
      </Modal.Body>
    </Modal>
  );
}

export default WaitingListModal;
